<template>
  <div class="home-div">
    <div class="home-top">
      <img class="message-icon" src="../../assets/home/message-icon.png">
      <div class="message-box">
        <div class="scroll-y">
          <AutoScroll :height="125" :step="125" :counts="notice.length" :duation="5000">
            <div v-for="(item, i) in notice" :key="i" class="message" :title="item.id">
              {{ item.area_name + ' ' + item.deviceName }} 发生预警请及时查看
            </div>
          </AutoScroll>
        </div>
      </div>
    </div>
    <div class="home-con">
      <div class="scroll-box scroll-y">
        <div class="home-con-top">
          <div class="con-left">
            <img src="../../assets/home/Ai-icon.png">
            <div class="title">
              视频监管
            </div>
            <div class="btn-box">
              <div class="btn mr-10" @click="pathTo('VideoSurveillance')">监控视频</div>
              <div class="btn ml-10 mr-10" @click="pathTo('DataExamine')"><div class="warning-num" v-if="noticeTotal > 0">{{ noticeTotal }}</div>数据审核</div>
              <div class="btn ml-10" @click="pathTo('VideoManage')">点位管理</div>
            </div>
          </div>
          <div class="con-right">
            <img src="../../assets/home/big-data-icon.png">
            <div class="title">
              实时调度
            </div>
            <div class="btn-box">
              <div class="btn" @click="pathTo('DataScreen')">数据大屏</div>
            </div>
          </div>
        </div>
        <div class="home-con-bottom">
          <div class="height-box">
            <img src="../../assets/home/yjda.png">
            <div class="title">
              综合管理
            </div>
            <div class="btn-box">
              <div class="btn mr-10" @click="pathTo('WarningManage')">报警管理</div>
              <div class="btn" @click="pathTo(false)">算法设置</div>
            </div>
          </div>
          <div class="height-box">
            <img src="../../assets/home/data-center.png">
            <div class="title">
              数据中心
            </div>
            <div class="btn-box">
              <div class="btn mr-10" @click="pathTo('HistoricalRanking')">历史排名</div>
              <div class="btn ml-10 mr-10" @click="pathTo('HistoricalData')">历史数据</div>
              <div class="btn ml-10 mr-10" @click="pathTo('DataAnalysis')">数据分析</div>
              <div class="btn ml-10" @click="pathTo('AssociationMining')">关联挖掘</div>
            </div>
          </div>
          <div class="short-box">
            <img src="../../assets/home/set-icon.png">
            <div class="title">
              后台管理
            </div>
            <div class="btn-box">
              <div class="btn" @click="pathTo('User')">账号管理</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AutoScroll from "../../components/AutoScroll/index"
import { getWarningList } from "../../api/warning";

export default {
  name: "index",
  components: {
    AutoScroll
  },
  data () {
    return {
      notice: [],
      noticeTotal: 0
    }
  },
  mounted() {
    this.$bus.on('refreshWarning', () => {
      this.getWarningList()
    })
    this.getWarningList()
  },
  destroyed() {
    this.$bus.off('refreshWarning')
  },
  methods: {
    pathTo (name) {
      if (!name) {
        return this.$message.warning('该模块开发中...')
      }
      this.$router.push({ name: name })
    },
    getWarningList () {
      getWarningList({status: 0,page: 1,limit: 10}).then(res => {
        this.notice = res.data.list
        this.noticeTotal = res.data.totalCount
      })
    }
  }
}
</script>

<style scoped lang="less">
  .home-div{
    height: calc(100vh - 125px);
    padding: 10px 20px;
    .home-top{
      height: 144px;
      width: 100%;
      display: flex;
      align-items: center;
      .message-icon{
        width: 144px;
        height: 144px;
      }
      .message-box{
        width: calc(100% - 144px);
        height: 125px;
        background-image: url("../../assets/home/message-box.png");
        background-size: 100% 100%;
        padding-left: 40px;
        font-size: 28px;
        font-weight: 400;
        line-height: 125px;
        color: #00FFEE;
        .message{
          width: 100%;
          white-space:nowrap;
          overflow:hidden;
          text-overflow:ellipsis;
          cursor: pointer;
        }
        .scroll-y{
          height: 125px;
        }
      }
    }
    .home-con{
      margin-top: 20px;
      width: 100%;
      height: calc(100% - 164px);
      background-image: url("../../assets/home/con-box.png");
      background-size: 100% 100%;
      padding-top: 20px;
      .title{
        font-size: 42px;
        font-weight: bold;
        color: #FFFFFF;
        margin-top: 200px;
        text-align: center;
        transform: scale(1, 0.9);
        text-shadow: 3px 3px 5px #32b0f8;
      }
      .btn-box{
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        .btn{
          background-image: url("../../assets/home/btn-box.png");
          background-size: 100% 100%;
          min-width: 141px;
          padding: 0 30px;
          height: 61px;
          text-align: center;
          line-height: 61px;
          font-size: 22px;
          font-weight: 500;
          color: #FFFFFF;
          cursor: pointer;
          position: relative;
          .warning-num{
            border-radius: 10px;
            background-color: #ff0000;
            min-width: 20px;
            height: 20px;
            position: absolute;
            right: -10px;
            top: -5px;
            padding: 0 5px;
            font-size: 14px;
            line-height: 20px;
          }
        }
      }
      .scroll-box{
        width: 100%;
        overflow-y: auto;
        height: 97%;
        .home-con-top{
          display: flex;
          padding: 50px 40px 20px 40px;
          .con-left{
            width: 962px;
            height: 330px;
            background-image: url("../../assets/home/con-left.png");
            background-size: 100% 100%;
            margin-right: 30px;
            position: relative;
            img{
              position: absolute;
              top: 0px;
              left: 50%;
              transform: translate(-50%, -40%);
              width: 35%;
              height: auto;
            }
          }
          .con-right{
            width: 781px;
            height: 330px;
            background-image: url("../../assets/home/con-right.png");
            background-size: 100% 100%;
            margin-left: 30px;
            position: relative;
            img{
              position: absolute;
              top: 0px;
              left: 50%;
              transform: translate(-50%, -40%);
            }
          }
        }
        .home-con-bottom{
          padding: 0px 40px;
          display: grid;
          grid-template-columns: 1fr 2fr 1fr;
          grid-column-gap: 20px;
          height: 331px;
          .height-box{
            background-image: url("../../assets/home/height-box.png");
            background-size: 100% 100%;
            position: relative;
            img{
              position: absolute;
              top: 0px;
              left: 50%;
              transform: translate(-50%, -15%);
            }
          }
          .short-box{
            background-image: url("../../assets/home/short-box.png");
            background-size: 100% 100%;
            position: relative;
            img{
              position: absolute;
              top: 0px;
              left: 50%;
              transform: translate(-50%, -15%);
            }
          }
        }
      }
    }
  }
</style>
